<script>
    import Helpers from '@/tools/Helpers';
    import {TweenMax} from 'gsap';
    import opensocial from '@/assets/svg/share.svg';
    import icons from '@/assets/svg/social';
    import vk from '@/assets/svg/social/vk.svg';
    import fb from '@/assets/svg/social/fb-new.svg';
    import 'swiper/dist/css/swiper.css';
    import { swiper, swiperSlide } from 'vue-awesome-swiper';

    export default {
        name: 'articleMix',
        data() {
            return {
                openSocial: false,
                swiperOption: {
                    slidesPerView: 'auto',
                    centeredSlides: true,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    breakpoints: {
                        769: {
                            spaceBetween: 0,
                            loop: true,
                        }
                    },
                    on: {
                        slideChange: function () {
                            Helpers.ga().send('longread','click','slide');
                        },
                        click:function () {
                            let Clickindex = this.clickedIndex;

                            if (this.activeIndex === Clickindex + 1) {
                                this.slidePrev();
                            }
                            else if (this.activeIndex === Clickindex - 1) {
                                this.slideNext();
                            }
                        }
                    },
                },

                swiperProductOption: {
                    slidesPerView: 1,
                    centeredSlides: true,
                    autoHeight: true,
                    hideOnClick: true,
                    pagination: {
                        el: '.swiper-pagination',
                    },
                },

                scrollTop: 0,
                pageHeight: 0,
                firstScrolled: false,
                scroll25 : false,
                scroll50 : false,
                scroll75 : false,
                scroll100 : false,
                nextFlag: false
            }
        },

        components: {
            swiper,
            swiperSlide,
            vk: icons.vk,
            fb,
            ok: icons.ok,
            googleplus: icons.googleplus,
            tw: icons.tw,
            opensocial,
        },

        methods: {
            controls(e){
                let videoTag = this.$refs['video'];
                let btn = e.target;

                if( videoTag.paused === true ){
                    videoTag.play ();
                    btn.classList.remove('btn-pause');
                    btn.classList.add('btn-play');
                } else {
                    videoTag.pause ();
                    btn.classList.remove('btn-play');
                    btn.classList.add('btn-pause');
                }
            },

            gaEvents(ctegory,event,label){
                Helpers.ga().send(ctegory,event,label);
            },

            scrollToTop() {
                this.$refs['scrollBar'].scrollTop = document.getElementById(this.$route.name).getBoundingClientRect().top;
            },
            checkBlock (block){
                return (block.getBoundingClientRect().top>=-window.innerHeight/2 && block.getBoundingClientRect().top<window.innerHeight/2)
            },
            getPageRoute (id) {
                return id === 'index'?'/':'/'+id;
            },
            onScroll (e) {
                let block = document.querySelectorAll('.animate-img, .animate-block, .quotes');
                for (let i=0;i<block.length;i++){
                    if (this.checkBlock(block[i])){
                        block[i].classList.add('show');
                    }
                }

                // start gaEvent Scroll
                const scrollTop = e.target.scrollTop;
                const windowHeight = window.innerHeight;

                let scrollPercent = Math.round( (scrollTop / (this.pageHeight - windowHeight)  ) * 100);
                let ResScrollPercent = Math.abs(scrollPercent);

                if (ResScrollPercent >= 25 && !this.scroll25) {
                    this.$root.gaSend('longread','scroll','25%');
                    this.scroll25 = true;
                }
                if (ResScrollPercent >= 50 && !this.scroll50) {
                    this.$root.gaSend('longread','scroll','50%');
                    this.scroll50 = true;
                }
                if (ResScrollPercent >= 75 && !this.scroll75) {
                    this.$root.gaSend('longread','scroll','75%');
                    this.scroll75 = true;
                }
                if (ResScrollPercent >= 100 && !this.scroll100) {
                    this.$root.gaSend('longread','scroll','100%');
                    this.scroll100 = true;
                }
                // finish gaEvent Scroll
            },

            closeShare() {
                this.openSocial = false;
            },
            toggleSocial(){
                this.openSocial=!this.openSocial
                this.gaEvents('main','click','share');
            },
        },
        mounted(){
            this.scrollToTop();
            this.pageHeight = document.querySelector('#scrollBar').scrollHeight;

            // let videoTag = this.$refs['video'];
            // let seekBar = this.$refs['range'];
            //
            // seekBar.addEventListener("change", function() {
            //     let time = videoTag.duration * (seekBar.value / 100);
            //     videoTag.currentTime = time;
            // });
            //
            // videoTag.addEventListener("timeupdate", function() {
            //     let value = (100 / videoTag.duration) * videoTag.currentTime;
            //     seekBar.value = value;
            // });
            //
            // seekBar.addEventListener("mousedown", function() {
            //     videoTag.pause();
            // });
            //
            // seekBar.addEventListener("mouseup", function() {
            //     videoTag.play();
            // });
        },

    }
</script>



// WEBPACK FOOTER //
// article_mix.vue?1025425a